import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import filters from './filters.js'  //not currently used
import VueMoment from 'vue-moment'


Vue.use(VueMoment);
Vue.config.productionTip = false

//amplify authentication
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import config from './aws-exports'

Amplify.configure(config)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.config.productionTip = false


new Vue({
  vuetify,
  router,
  store,
  filters,
  render: h => h(App)
}).$mount('#app')
